import type { PublicAddress as GQLPublicAddress } from '../generated/checkout.graphql';
import type { Address as GQLAddress } from '../generated/graphql';
import { take } from '../util/takePayload';

export interface Address {
  street1: string;
  street2?: string;
  city: string;
  state?: string;
  postalCode: string;
  country: string;
}

export const getNew = (): Address => ({
  street1: '',
  street2: '',
  city: '',
  state: '',
  postalCode: '',
  country: 'US',
});

export const fromGql = (gqlAddress: GQLAddress | GQLPublicAddress): Address => ({
  ...(take(gqlAddress, 'street1', 'street2', 'city', 'state', 'postalCode', 'country') as Address),
});
